import React from "react";
import { HeroSection } from "./HeroSection";
import { NewsBanner } from "./NewsBanner";
import { UnlockGrowthSection } from "./UnlockGrowthSection";
import { BravoDifferenceSection } from "./BravoDifferenceSection";
import { EnterpriseSolutionsSection } from "./EnterpriseSolutionsSection";
import { TabbedSolutionsSection } from "./TabbedSolutionsSection";
import { PlatformSection } from "./PlatformSection";
import { HowItWorksSection } from "./HowItWorksSection";
import { GetStartedSection } from "./GetStartedSection";

export const HomeLayout: React.FC = () => {
  return (
    <>
      <HeroSection />
      <NewsBanner />
      <UnlockGrowthSection />
      <BravoDifferenceSection />
      <EnterpriseSolutionsSection />
      <TabbedSolutionsSection />
      <PlatformSection />
      <HowItWorksSection />
      <GetStartedSection />
    </>
  );
};
